<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                feedPurchaseForm: () => import('../forms/FeedPurchaseForm'),
                loadForm: () => import('../forms/LoadForm'),
                fields: [
                    { type: 'autocomplete', text: 'Load', value: 'loadId', rules: [v => !!v || 'Load is required'], isRequired: true, form: () => import('./LoadForm'), apiMethod: 'Loads', claim: 'Loads' },
                    { type: 'autocomplete', text: 'Feed Purchase', value: 'feedPurchaseId', rules: [v => !!v || 'Feed Purchase is required'], isRequired: true, form: () => import('./FeedPurchaseForm'), apiMethod: 'FeedPurchases', claim: 'FeedPurchases' },
                    { type: 'datetime', text: 'Applied On', value: 'appliedOn', rules: [v => !!v || 'Applied On is required'], isRequired: true },
                    { type: 'number', text: 'Amount In Millilitres', value: 'amountInMillilitres', rules: [] },
                    { type: 'number', text: 'Amount In Grams', value: 'amountInGrams', rules: [] },
                ],
                apiMethod: 'Feedings',
                formTitle: 'Feeding',
            }
        },
    };
</script>
